import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Snackbar } from 'Packages/FacetDesign/Components/Snackbar';
import { FDDisplayText } from '@facet-wealth/design';
import { PillarActions } from 'Views/Page/Content/Templates/ClientDashboardPageTemplate/Organisms/PillarActions';
import { PillarProgress } from './Organisms/PillarProgress';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('loadMessage', {
    _component: () => Snackbar,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('progress', { _component: () => PillarProgress }, overrideReadOnly)
  .nameOverride('pillars', { _component: () => PillarActions }, overrideReadOnly);
